<template>
  <div class="TipsAndPrivewDilog" style="display: inline-block; position: relative;">
    <div class="name">
       
      <div style="display: inline-block;">
        <slot name="Text"></slot>
       
        <span v-if="IconUrl"  style="display: inline-block; position: relative;">  
          <img   v-bind:t_label="id"   style="padding: 4px; vertical-align: middle; display: inline-block;" :id="id" 
            :src="IconUrl"  @mouseenter="showTooltip"  @mouseleave="hideTooltip"  @mousemove="updateTooltipPosition"
            ref="iconRef"  > 
          <!-- 自定义tooltip -->
          <div  v-if="showTooltipFlag" 
            :class="['custom-tooltip', `tooltip-${placement}`]"
            :style="tooltipStyle"
          >
            <div class="tooltip-content" v-html="Title"></div>
            <div :class="['tooltip-arrow', `arrow-${placement}`]"></div>
          </div>
        </span>

         <span v-else>
          <i class="fa fa-info-circle m-l-5" :title="Title" v-bind:t_label="id" v-b-toggle="id"></i> 
        </span>

      </div>

    </div>
    

  </div>
</template>

<script>

export default {
  props: {
    // 0 提示 , 1 弹出右边dilog 预览
    Type: {
      type: Number,
      default: 0
    }, 
    Title:
    {
      type: String,
      default: ""
    },
    id:
    {
      type: String,
      default: ""
    },
    IconUrl:{
      type: String,
      default: ""
    },
    placement:{
      type: String,
      default: "bottom"
    }
  },
  data() {
    return {
      showTooltipFlag: false,
      tooltipStyle: {}
    }
  },
  watch: {

  },
  computed: {
    langid() {
      return localStorage.getItem("currentLangId")
    }
  },
  mounted() {

  },
  methods: {
    scrollToAdPosition() {
      if (this.$refs.Dialog && this.$refs.Dialog.$el) {
        const sidebarContent = this.$refs.Dialog.$el.querySelector('.b-sidebar-body') || 
                              this.$refs.Dialog.$el.querySelector('.card-body');
        if (sidebarContent) {
          sidebarContent.scrollTo({
            top: this.scrollToNums,
            left: 0,
            behavior: 'smooth'
          });
        }
      }
    },
    showTooltip(event) {
      this.showTooltipFlag = true;
      this.$nextTick(() => {
        this.updateTooltipPosition(event);
      });
    },
    hideTooltip() {
      this.showTooltipFlag = false;
    },
    updateTooltipPosition(event) {
      if (!this.showTooltipFlag) return;
      
      const icon = event ? event.target : (this.$refs.iconRef || this.$el.querySelector(`#${this.id}`));
      if (!icon) return;
      
      const iconRect = icon.getBoundingClientRect();
      const tooltip = this.$el.querySelector('.custom-tooltip');
      
      if (!tooltip) {
        this.$nextTick(() => {
          this.updateTooltipPosition(event);
        });
        return;
      }
      
      const tooltipRect = tooltip.getBoundingClientRect();
      
      let top = 0;
      let left = 0;
      
      if (this.placement === 'top') {
        // tooltip在icon上方，居中对齐
        top = iconRect.top - tooltipRect.height - 8;
        left = iconRect.left + (iconRect.width / 2) - (tooltipRect.width / 2);
      } else if (this.placement === 'bottom') {
        // tooltip在icon下方，居中对齐
        top = iconRect.bottom + 8;
        left = iconRect.left + (iconRect.width / 2) - (tooltipRect.width / 2);
      } else if (this.placement === 'left') {
        // tooltip在icon左侧，垂直居中
        top = iconRect.top + (iconRect.height / 2) - (tooltipRect.height / 2);
        left = iconRect.left - tooltipRect.width - 8;
      } else if (this.placement === 'right') {
        // tooltip在icon右侧，垂直居中
        top = iconRect.top + (iconRect.height / 2) - (tooltipRect.height / 2);
        left = iconRect.right + 8;
      }
      
      // 确保tooltip不会超出视口
      const viewportWidth = window.innerWidth;
      const viewportHeight = window.innerHeight;
      const padding = 10;
      
      // 水平边界检查
      if (left < padding) {
        left = padding;
      } else if (left + tooltipRect.width > viewportWidth - padding) {
        left = viewportWidth - tooltipRect.width - padding;
      }
      
      // 垂直边界检查
      if (top < padding) {
        top = padding;
      } else if (top + tooltipRect.height > viewportHeight - padding) {
        top = viewportHeight - tooltipRect.height - padding;
      }
      
      this.tooltipStyle = {
        position: 'fixed',
        top: `${top}px`,
        left: `${left}px`,
        zIndex: 10000
      };
    }
  }
}
</script>
<style lang="scss" scoped>
.TipsAndPrivewDilog {
  display: inline-block;
  position: relative;
}
</style>
<style lang="scss">
// 自定义tooltip样式
.custom-tooltip {
  position: fixed;
  z-index: 10000;
  pointer-events: none;
  animation: tooltipFadeIn 0.2s ease-out;
}

@keyframes tooltipFadeIn {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.tooltip-content {
  background: linear-gradient(180deg, #7366FF 0%, #7366FF 100%);
  color: #fff;
  border: 1px solid #7366FF;
  // box-shadow: 0 8px 18px rgba(0, 0, 0, 0.18);
  font-size: 14px;
  line-height: 18.20px;
  padding: 8px;
  border-radius: 4px;
  white-space: nowrap;
  text-align: center;
  position: relative;
}

.tooltip-arrow {
  position: absolute;
  width: 0;
  height: 0;
  border-style: solid;
}

// 顶部tooltip的箭头（在底部）
.tooltip-top .tooltip-arrow {
  bottom: -6px;
  left: 50%;
  transform: translateX(-50%);
  border-width: 6px 6px 0 6px;
  border-color: #7366FF transparent transparent transparent;
}

// 底部tooltip的箭头（在顶部）
.tooltip-bottom .tooltip-arrow {
  top: -5px;
  left: 50%;
  transform: translateX(-50%);
  border-width: 0 6px 6px 6px;
  border-color: transparent transparent #7366FF transparent;
}

// 左侧tooltip的箭头（在右侧）
.tooltip-left .tooltip-arrow {
  right: -5px;
  top: 50%;
  transform: translateY(-50%);
  border-width: 6px 0 6px 6px;
  border-color: transparent transparent transparent #7366FF;
}

// 右侧tooltip的箭头（在左侧）
.tooltip-right .tooltip-arrow {
  left: -5px;
  top: 50%;
  transform: translateY(-50%);
  border-width: 6px 6px 6px 0;
  border-color: transparent #7366FF transparent transparent;
}
</style>